// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"34":"e48d8e2f2f31807a","480":"f0f39c86f5c1d1cf"}[chunkId] + ".js";
};